import React from "react";
import { ReactComponent as InfoIcon } from "../../Assets/Icons/info.svg";
import { ReactComponent as EyeShow } from "../../Assets/Icons/eyeShow.svg";
import { ReactComponent as EyeHide } from "../../Assets/Icons/eyeHide.svg";

const Input = ({
  type,
  label,
  labelClassName,
  placeholder,
  width,
  radius,
  InputDivClass,
  name,
  value,
  handleChange,
  handleBlur,
  error,
  touched,
  onClick,
  handleKeyDown,
  readonly,
  inputClass,
  disabled,
  info,
  showPassword, // NEW PROP
  togglePassword, // NEW PROP
  ...rest
}) => {
  console.log("error", error);

  const nameFields = ['firstName', 'lastName'];
  const personNameFields = ['personName']; // Contact person names can include digits
  const businessNameField = ['businessName', 'fundraiserName'];
  const numberFields = ['personContact'];

  // Function to prevent numeric input for name fields
  const handleKeyPress = (e) => {
    if (nameFields.includes(name)) {
      // Allow letters, spaces, backspace, delete, tab, escape, enter
      const allowedKeys = /[a-zA-Z\s]/;
      const specialKeys = [8, 9, 27, 13, 46]; // backspace, tab, escape, enter, delete

      if (!allowedKeys.test(e.key) && !specialKeys.includes(e.keyCode)) {
        e.preventDefault();
      }
    } else if (personNameFields.includes(name)) {
      // Allow letters, numbers, and spaces for contact person names
      const allowedKeys = /[a-zA-Z0-9\s]/;
      const specialKeys = [8, 9, 27, 13, 46]; // backspace, tab, escape, enter, delete

      if (!allowedKeys.test(e.key) && !specialKeys.includes(e.keyCode)) {
        e.preventDefault();
      }
    } else if (businessNameField.includes(name)) {
      // Allow letters, numbers, spaces, and special characters as defined in validation schema
      // Matches the regex from validation: /^[\p{L}0-9\s&'().,\-@#$%!?/:;+=_*[\]{}|~`"\\]+$/u
      const allowedKeys = /[a-zA-Z0-9\s&'().,\-@#$%!?/:;+=_*[\]{}|~`"\\]/;
      const specialKeys = [8, 9, 27, 13, 46]; // backspace, tab, escape, enter, delete

      if (!allowedKeys.test(e.key) && !specialKeys.includes(e.keyCode)) {
        e.preventDefault();
      }
    } else if (numberFields.includes(name)) {
      const allowedKeys = /[0-9]/;
      const specialKeys = [8, 9, 27, 13, 46];

      if (!allowedKeys.test(e.key) && !specialKeys.includes(e.keyCode)) {
        e.preventDefault();
      }
    }
  };

  const handleInputChange = (e) => {
    if (!handleChange) return;

    if (numberFields.includes(name)) {
      const digitsOnly = e.target.value.replace(/[^0-9]/g, "");
      if (digitsOnly !== e.target.value) {
        e.target.value = digitsOnly;
      }
    }
    handleChange(e);
  };

  const numericInputProps = numberFields.includes(name)
    ? { inputMode: "numeric", pattern: "[0-9]*" }
    : {};

  return (
    <div className={`${InputDivClass} relative`}>
      <p className={`${label !== "" ? `label-text mb-2 block ${labelClassName || ""}` : ""}`}>{label}</p>
      {readonly === true ? (
        <input
          type={type ? type : "text"}
          name={name}
          value={value}
          placeholder={placeholder}
          className={`invitationInputs ${inputClass} ${disabled ? "cursor-not-allowed" : ""}`}
          style={{ width: width, borderRadius: radius }}
          onChange={handleInputChange}
          onBlur={handleBlur}
          onKeyPress={handleKeyPress}
          onClick={onClick}
          disabled={disabled}
          onKeyDown={handleKeyDown}
          readOnly
          {...numericInputProps}
          {...rest}
        />
      ) : (
        <div className="flex flex-col items-start justify-start gap-2 w-full">
          <div className="relative w-full">
            <input
              type={type ? type : "text"}
              name={name}
              value={value}
              placeholder={placeholder}
              className={`invitationInputs ${inputClass} pr-10`}
              style={{ width: width, borderRadius: radius }}
              onChange={handleInputChange}
              onBlur={handleBlur}
              onKeyPress={handleKeyPress}
              onClick={onClick}
              onKeyDown={handleKeyDown}
              disabled={disabled}
              {...numericInputProps}
              {...rest}
            />
            {togglePassword && (type === "password" || type === "text") && (
              <button
                type="button"
                onClick={togglePassword}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 focus:outline-none"
                tabIndex={-1}
              >
                {showPassword ? (
                  <EyeShow style={{ width: 24, height: 26 }} />
                ) : (
                  <EyeHide style={{ width: 24, height: 26 }} />
                )}
              </button>
            )}
          </div>
          {info ? (
            <div className="flex justify-start items-center gap-2">
              <InfoIcon />
              <p className="font-poppins font-[400] text-[14px] text-[#767676]">
                {info}
              </p>
            </div>
          ) : null}
        </div>
      )}
      {error && touched ? (
        <div className="ms-1">
          <span className="text-red-600 text-[8px] sm:text-[10px] md:text-[12px] font-[600] text-start">
            {error}
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default Input;
